// @flow
/**
 * Text table cell
 * Supported options
 * template {String} Underscore template to run against cell content.
 * types {Object} Defines data types that will be used to convert cell content values
 */
import { _ } from "extensions/underscore";

import type { ColumnType } from "./generic";

import {
    Presenter,
    HeaderView
} from "./generic";
import { RatePresenter } from "./rate";
import { NumberPresenter } from "./number";
import { AmountPresenter } from "./amount";

export const TextHeaderView = HeaderView.extend({
    type: "text",
    className: "text-column-header"
});

export class TextPresenter extends Presenter {
    itemContent = (column: ColumnType, content, rowModel) => {
        let formattedContent = content;
        
        if (column.cellOptions.template) {
            formattedContent = _.mapObject(content, (value, key) => {
                if (column.cellOptions.types[key] === "number") {
                    return new NumberPresenter().itemContent(column, value, rowModel);
                } if (column.cellOptions.types[key] === "amount") {
                    return new AmountPresenter().itemContent(column, value, rowModel);
                } if (column.cellOptions.types[key] === "rate") {
                    return new RatePresenter().itemContent(column, value, rowModel);
                }
                
                return value;
            });
            
            return column.cellOptions.template(formattedContent);
        }
        
        if (!column.cellOptions.html && typeof content === "string") {
            formattedContent = _.escape(content);
        }
        
        return formattedContent;
    };
    
    additionalValueClassNames = (column: ColumnType) => {
        if (column.cellOptions.template && column.cellOptions.types) {
            return Object.keys(column.cellOptions.types).map((k: string): string => `text-template-${k}`);
        }
        return [];
    };
}
